export enum ManufactureOrderState {
  Draft,
  InProgress,
  WaitForDeliver,
  Delivered,
  Canceled,
}
